import React, { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import * as Icons from '@core/icons-react';
import type { EntityNodeData } from '../../types';
import './EntityNode.scss';

export const EntityNode = memo(({ data, selected }: NodeProps) => {
  const nodeData = data as EntityNodeData;
  const { entityType, label, config } = nodeData;

  const IconComponent = config?.icon
    ? (Icons as Record<string, React.ComponentType<{ size?: number }>>)[config.icon]
    : Icons.CircleDash;

  return (
    <div className={`graph-entity-node ${selected ? 'graph-entity-node--selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="graph-entity-node__handle" />

      <div className="graph-entity-node__icon">
        {IconComponent && <IconComponent size={16} />}
      </div>

      <div className="graph-entity-node__content">
        <span className="graph-entity-node__type">{config?.title || entityType}</span>
        <span className="graph-entity-node__label">{label}</span>
      </div>

      <Handle type="source" position={Position.Bottom} className="graph-entity-node__handle" />
    </div>
  );
});

EntityNode.displayName = 'EntityNode';



